<template>
  <div class="wd-flex wd-flex-col wd-items-center wd-justify-center wd-gap-5 wd-min-h-100">
    <v-img class="gift-empty__image wd-w-30" src="@/assets/images/gift/gift-question.svg?url" max-width="120" max-height="90" />
    <p class="empty-text wd-text-gray80 wd-text-omd wd-text-center wd-whitespace-pre-line !wd-mb-0">{{ props.emptyText }}</p>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  emptyText: string
}

const props = defineProps<Props>()
</script>
